import { Check } from 'lucide-react';
import type { ReactNode } from 'react';
import { Checkbox as AriaCheckbox } from 'react-aria-components';
import styles from './Checkbox.module.css';

interface CheckboxProps {
  isSelected: boolean;
  onChange: (selected: boolean) => void;
  children: ReactNode;
  isDisabled?: boolean;
  id?: string;
}

export function Checkbox({
  isSelected,
  onChange,
  children,
  isDisabled = false,
  id,
}: CheckboxProps) {
  return (
    <AriaCheckbox
      className={styles.checkbox}
      isSelected={isSelected}
      onChange={onChange}
      isDisabled={isDisabled}
      {...(id ? { id } : {})}
    >
      <span className={styles.box} aria-hidden="true">
        <Check size={16} strokeWidth={3} />
      </span>
      <span className={styles.label}>{children}</span>
    </AriaCheckbox>
  );
}
